// ExamLayout — Indigo theme, 60/40 split
//
// Left panel (60%): ContentPanel (exercises + content blocks)
// Right panel (40%): ChatPanel
// Mobile: ContentPanel stacks above ChatPanel

import type { ReactNode } from 'react';
import ContentPanel from '../session/ContentPanel';
import type { ToolResult } from '@hooks/useAnnaChat';

interface ExamLayoutProps {
  chatPanel: ReactNode;
  toolResults: ToolResult[];
  accentColor: string;
  isStreaming?: boolean;
  onSubmitAnswer?: (answer: string) => void;
}

export default function ExamLayout({
  chatPanel,
  toolResults,
  accentColor,
  isStreaming,
  onSubmitAnswer,
}: ExamLayoutProps) {
  return (
    <div className="flex flex-col md:flex-row h-full">
      <div className="h-[40vh] md:h-full md:w-[60%] overflow-y-auto p-4">
        <ContentPanel
          toolResults={toolResults}
          accentColor={accentColor}
          isStreaming={isStreaming}
          onSubmitAnswer={onSubmitAnswer}
        />
      </div>
      <div className="flex-1 md:flex-none md:w-[40%] min-h-0">
        {chatPanel}
      </div>
    </div>
  );
}
